module.exports = __webpack_public_path__ + "quicksilver/static/media/paypal-footer.808e8d93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/paypal/paypal-footer.svg
// module id = 632
// module chunks = 0